function SuspenseContent(){
    return(
        <div className="w-full h-screen flex justify-center items-center bg-base-100">
            Loading...
        </div>
    )
}
export default SuspenseContent